import React from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import Breadcrumbs from '@techsoftware/happay-widgets/Breadcrumbs';
import Icons from '@techsoftware/happay-widgets/FontIcon';

const HeaderBreadCrumb = props => {
  const { pathname } = useLocation();
  const { match: { params: { id } = {} } = {} } = props;
  const route = {
    '/invoice/myinvoice': ['Invoice', 'My Invoice'],
    '/invoice/myapproval': ['Invoice', 'My Approvals'],
    '/vendor/myvendor': ['Vendor', 'My Vendor'],
    '/vendor/myapproval': ['Vendor', 'My Approval'],
  };

  const stack = [];

  const createPAthArray = () => {
    const tempPath = pathname;
    let trimmedPath = '';
    if (pathname.includes(id)) {
      trimmedPath = tempPath.replace(`/${id}`, '');
      if (trimmedPath in route) {
        stack.push(trimmedPath);
      }
    } else {
      stack.push(tempPath);
    }
  };
  createPAthArray();
  return (
    <Breadcrumbs separator={<Icons type="dropright" size="small" />}>
      <Link
        to="/dashboard"
        className={stack.includes('/dashboard') ? 'disable-link' : ''}
      >
        Dashboard
      </Link>
      {stack.map(el =>
        route[el]
          ? route[el].map(item => <Link className="disable-link">{item}</Link>)
          : null,
      )}
      {id && <Link to="/dashboard">Detail</Link>}
    </Breadcrumbs>
  );
};
export default HeaderBreadCrumb;
